<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="series"></import-navigator>
                <div class="wrap-text">
                    <b>
                        Define benchmarks and forecast
                    </b>
                    <span>
                        To create context and projections around your {{oldControlValue}} and {{newControlValue}} comparison
                    </span>
                </div>
            </div>
        </div>
        <div class="middle-part set-up">
            <div class="current-status">
                <div class="left">
                    <div class="dot green"></div>
                </div>
                <div class="divider"></div>
                <div class="right">
                    <div *ngIf="differentSeriesSelected && !selectedSeriesName;else sameSeriesSelected" class="wrap">
                        Multiple series selected as reference across all views, series “{{previousSelectedSeries}}” will be restored upon recalculation - organize your benchmarks below <help-link></help-link>
                    </div>
                    <ng-template #sameSeriesSelected>
                        <div class="wrap">
                            Series “{{selectedSeriesName}}” selected as reference series - organize your additional benchmarks below <help-link></help-link>
                        </div>
                    </ng-template>
                    <div *ngIf="!haveEligibleForForecast" class="wrap">
                        No benchmarks eligible as forward looking forecast <help-link></help-link>
                    </div>
                    <div *ngIf="haveEligibleForForecast && (!selectedAsForecast || !selectedAsForecast.length)" class="wrap">
                        No forward looking forecast selected - click on the eligible benchmarks below to change <help-link></help-link>
                    </div>
                    <div *ngIf="selectedAsForecast && selectedAsForecast.length == 1" class="wrap">
                        <b class="text-bracket">{{selectedAsForecast[0]}}</b> selected as forward looking forecast <help-link></help-link>
                    </div>
                    <div *ngIf="selectedAsForecast && selectedAsForecast.length == 2" class="wrap">
                        <b class="text-bracket">{{selectedAsForecast[0]}}</b> and <b class="text-bracket">{{selectedAsForecast[1]}}</b> selected as forward looking forecast <help-link></help-link>
                    </div>
                    <div *ngIf="selectedAsForecast && selectedAsForecast.length > 2" class="wrap">
                        <ng-container *ngFor="let val of selectedAsForecast.slice(0, -2)">
                            <b class="text-bracket">{{val}}</b>,
                        </ng-container>
                        <b class="text-bracket">{{selectedAsForecast[selectedAsForecast.length - 2]}}</b> and <b class="text-bracket">{{selectedAsForecast[selectedAsForecast.length - 1]}}</b> selected as forward looking forecast <help-link></help-link>
                    </div>
                    <div class="wrap">
                        <button (click)="saveSeries()" [ngClass]="{ 'loading-small': loading, 'btn':true, 'btn-green':true, 'btn-small':true }">Continue</button>
                        <span class="text-after-btn">when ready</span>
                    </div>
                </div>
            </div>
            <div class="table-series">
                <div *ngFor="let row of series; let rowIx = index" [ngClass]="{'row':true, 'row-red': row.isExclude}">
                    <div class="cell cell-radio">
                        <div (click)="toggleSeriesSelection(row.name, $event)" class="wrap-radio form-choice">
                            <input *ngIf="!row.isExclude" [checked]="selectedSeriesName == row.name" [id]="row.name" type="radio" class="form-choice-radio">
                            <label [for]="row.name"></label>
                        </div>
                        <div class="wrap-name">
                            <label *ngIf="!row.renaming" [for]="row.name">{{ row.name }}</label>
                            <a *ngIf="!row.renaming && !row.isExclude" (click)="row.renaming=true">rename</a>
                            <div *ngIf="row.renaming" class="flex-column rename">
                                <input [(ngModel)]="row.renamingName" [ngModelOptions]="{standalone: true}" type="text" />
                                <button (click)="finishRenaming(row)" class="btn btn-green btn-small">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let item of row.items; let colIx = index" [ngClass]="{ 'figure-block':(movingItem || multiSelectEndedAt), 'green':item && (item.isSelectedAsForecast || item.isMultiSelected), 'cell':true, 'cell-data':true, 'on-hover':true, 'many-links': true }">
                        <span *ngIf="item && item.isCurrentlyEligibleAsForecast && !item.isSelectedAsForecast" class="elligible"></span>
                        <span *ngIf="item && item.isOldControlValue" class="control-left"></span>
                        <span *ngIf="item && item.isNewControlValue" class="control-right"></span>
                        <span *ngIf="item">{{item.controlValue}}</span>
                        <a *ngIf="!movingItem && !multiSelectStartedAt && item && item.isCurrentlyEligibleAsForecast && !item.isSelectedAsForecast" (click)="selectAsForecast(item)" class="hover-btn">Add as forecast</a>
                        <a *ngIf="!movingItem && !multiSelectStartedAt && item && item.isSelectedAsForecast" (click)="unSelectAsForecast(item)" class="hover-btn">Remove as forecast</a>
                        <a *ngIf="!movingItem && !multiSelectStartedAt && item && !item.isSelectedAsForecast" (click)="startMovingItem(rowIx, colIx)" class="hover-btn">Move</a>
                        <a *ngIf="!movingItem && !multiSelectStartedAt && item && !item.isSelectedAsForecast && item.canStartMultiSelect" (click)="startMultiSelect(rowIx, colIx)" class="hover-btn">Start selection</a>
                        <a *ngIf="multiSelectStartedAt && !multiSelectEndedAt && item && !item.isSelectedAsForecast && item.canEndMultiSelect && !multiSelectEndedAt" (click)="endMultiSelect(rowIx, colIx)" class="hover-btn">End selection</a>
                        <a *ngIf="multiSelectStartedAt && !multiSelectEndedAt && item && !item.canEndMultiSelect" (click)="cancelMultiSelect()" class="hover-btn">Cancel selection</a>
                        <a *ngIf="multiSelectEndedAt && item && item.isMultiSelected" (click)="cancelMultiSelect()" class="hover-btn">Cancel selection</a>
                        <ng-container *ngIf="movingItem || (multiSelectEndedAt && !(item && item.isMultiSelected))">
                            <div (click)="insertAbove(rowIx, colIx)" class="figure block-figure block-top"></div>
                            <div class="block-wrap block-right">
                                <div (click)="insertRightFrom(rowIx, colIx)" class="figure right"></div>
                                <div (click)="insertRightFrom(rowIx, colIx)" class="right-triangle right-triangle_top"></div>
                                <div (click)="insertRightFrom(rowIx, colIx)" class="right-triangle"></div>
                            </div>
                            <div (click)="insertBelow(rowIx, colIx)" class="figure block-figure block-bottom"></div>
                            <div class="block-wrap block-left">
                                <div (click)="insertLeftFrom(rowIx, colIx)" class="figure left"></div>
                                <div (click)="insertLeftFrom(rowIx, colIx)" class="left-triangle left-triangle_top"></div>
                                <div (click)="insertLeftFrom(rowIx, colIx)" class="left-triangle"></div>
                            </div>
                            <div (click)="swapWith(rowIx, colIx)" class="figure middle"></div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
